<template>
  <el-row style="background:#fff; height:1000px;">
    <el-row style="width:70%; margin:0 auto;">
      <!-- 登录区 -->
      <el-row >
      <!-- banner -->
      <el-row class="banner"  >
        <el-row class="head">
          <el-col :span="22" class="head_logo" >
            <img :src="log1"  height="46px"/>
          </el-col>
          <!-- 增加用户信息，下拉菜单 -->
          <el-col :span="2" class="head_right">
            <div class="Head_Link">
                <!-- &nbsp;管理登录 -->
              <el-button class="t" type="text" :style="dh" style="padding-left:40px" >
                &nbsp;400-878-6390
              </el-button>
            </div>
          </el-col>
        </el-row> 
      </el-row>
        <!-- header is over -->
        <div class="content main">
          <div class="jf">
            <div class="dlck" style="float: left;">
              <h3 class="h3">
                    西安翻译学院
              </h3>
              <div>
              </div>
              <el-row style="margin-top: 14px">
                <el-form :model="global.curUser" ref="form" label-width="80px">
                  <el-form-item label="学生姓名">
                    <el-input v-model="form.studentName" placeholder="请输入" :class="Ginkgo.getEditItemClass(global.editInline)"></el-input>
                  </el-form-item>
                  <el-form-item label="学号">
                    <el-input v-model="form.studentNo" placeholder="请输入" :class="Ginkgo.getEditItemClass(global.editInline)"></el-input>
                  </el-form-item>
                </el-form>
                
                <el-row style="width:100%;margin: 20px auto;"><el-button style="width: 100%" type="success" @click="loginInit()">登录</el-button></el-row>
              </el-row>
            </div>
            <div style="width: 545px; height: 330px; float: right; margin-top:10px;">
              <!-- <div id="idContainer2" class="container" style="margin:8px 8px 0px 0px; background: #000; width: 590px; height: 370px;border:1px solid #CCC;" > -->
                <el-carousel indicator-position="outside" >
                  <el-carousel-item>
                    <img :src="fy1"  height="300px" width="545px"/>
                  </el-carousel-item>
                  <el-carousel-item>
                    <img :src="fy2" height="300px" width="545px"/>
                  </el-carousel-item>
                  <el-carousel-item>
                    <img :src="fy3" height="300px" width="545px"/>
                  </el-carousel-item>
                  <el-carousel-item>
                    <img :src="fy4" height="300px" width="545px"/>
                  </el-carousel-item>
                </el-carousel>
            </div>
          </div>
        </div>
        <div class="tybottom">
					<div class="main_down">
              <div class="down_gg fl">
                  <h2>咨询电话</h2>
                    <ul class="gg">
                      <li v-if="!(financeOffice.modeName === undefined)"><span style="font-size: 16px;font-weight:bolder;">{{financeOffice.modeName}}：{{financeOffice.modeValue}}</span></li>
                      <li v-if="!(apartmentOffice.modeName === undefined)"><span style="font-size: 16px;font-weight:bolder;">{{apartmentOffice.modeName}}：{{apartmentOffice.modeValue}}</span></li>
                      <li v-if="!(deanOffice.modeName === undefined)"><span style="font-size: 16px;font-weight:bolder;">{{deanOffice.modeName}}：{{deanOffice.modeValue}}</span></li>
                      <li v-if="!(admissionsOffice.modeName === undefined)"><span style="font-size: 16px;font-weight:bolder;">{{admissionsOffice.modeName}}：{{admissionsOffice.modeValue}}</span></li>
                    </ul>
              </div>
 							<div class="down_gg fr">
     						<h2>帮助电话</h2>
 								<ul class="bzzx">
 								<li v-if="!(technicalSupport.modeName === undefined)"><span style="font-size: 18px;font-weight:bolder;">{{technicalSupport.modeName}}：{{technicalSupport.modeValue}}</span></li>
 								<!-- <li><span style="font-size: 18px;font-weight:bolder;">{{informationManagementCenter.modeName}}：{{informationManagementCenter.modeValue}}</span></li> -->
 								</ul>
 							</div>
 					</div>
        </div>
        <div>
          <router-view></router-view>
        </div>
      </el-row>
     </el-row> 
  </el-row>
</template>
<script>
export default {
  name: 'LoginDormOld', // ?
  data: function () {
    return {
      dh: {
        backgroundImage: 'url(' + this.global.staticResourceAddr + 'gsvvuepc/phone' + '.png' + ')',
        backgroundRepeat: 'no-repeat'
      },
      form: {
        studentName: '',
        studentNo: ''
      },
      route: [],
      log1: this.global.staticResourceAddr + 'gsvvuepc/logo1.png',
      fy1: this.global.staticResourceAddr + 'gsvvuepc/fy1.jpg',
      fy2: this.global.staticResourceAddr + 'gsvvuepc/fy2.jpg',
      fy3: this.global.staticResourceAddr + 'gsvvuepc/fy3.jpg',
      fy4: this.global.staticResourceAddr + 'gsvvuepc/fy4.jpg',

      financeOffice: {},
      apartmentOffice: {},
      deanOffice: {},
      admissionsOffice: {},
      technicalSupport: {},
      informationManagementCenter: {},
      customerService: {}
    }
  },
  mounted: function () {
    if (process.env.NODE_ENV === 'production') {
      // 登录默认
      this.getMode()
      this.getPhoneMode()
      this.form.studentName = ''
      this.form.studentNo = ''
    }
  },
  methods: {
    getMode: function () {
      this.modeSelectList = this.global.modeList
    },
    getPhoneMode: function () {
      this.global.phoneModeList.filter(item => {
        switch (item.modeId) {
          case '00': this.financeOffice = item
            break
          case '01': this.apartmentOffice = item
            break
          case '02': this.deanOffice = item
            break
          case '03': this.admissionsOffice = item
            break
          case '04': this.technicalSupport = item
            break
          case '05': this.informationManagementCenter = item
            break
          case '06': this.customerService = item
            break
        }
      })
    },
    // 获取待缴费账单（核准状态）
    loginInit: function () {
      if (process.env.NODE_ENV === 'production') {
        if (this.form.studentName === '' || this.form.studentNo === '') {
          this.$alert('学生姓名或者学号不能为空！')
        } else {
          this.logincheck()
        }
      } else {
        if (this.form.studentName === '' || this.form.studentNo === '') {
          this.$alert('学生姓名或者学号不能为空！')
        } else {
          this.toDormOld()
        }
      }
    },
     // 登录前检查否在导入学生表
    logincheck: function () {
      var self = this
      if (process.env.NODE_ENV === 'production') {
        this.axios.get('/college/logincheck', {
          params: {
            schoolYear: self.modeSelector('CM_OldStuPayTime')[0].modeValue,
            studyNo: self.form.studentNo.trim(),
            name: self.form.studentName.trim()
          }
        })
        .then(function (response) {
          if (response.data.result.success === true) {
            if (response.data.studentList.length > 0) {
              self.global.curStudent = response.data.studentList[0]
              self.toDormOld()
            } else {
              self.$alert('登陆失败!')
            }
          } else {
            self.$alert('服务出错!')
          }
        }, response => {
        })
        .catch(function (error) {
          console.log(error)
        })
      }
    },
    // 数据字典筛选器
    modeSelector: function (typeId) {
      let list = []
      list = this.modeSelectList.filter(function (element) {
        return element.typeId === typeId
      })
      return list
    },
    toDormOld: function () {
      this.$router.push('/DormOld')
      this.route = [{ path: '/DormOld', component: require('./DormOld.vue'), meta: { title: '选宿舍' } }]
      this.$router.addRoutes(this.route)
    }
  }
}
</script>

<style>
/*********通用bottom************/
.tybottom{width:1000px; height:236px; margin:10px auto;}
.main{ width:1000px;margin:0 auto;}
.main_down{width: 1000px;height: 200px;margin:10 auto;}
.down_gg{width: 490px;height: 200px;border: 1px solid #eaeaea;} 
.down_gg h2{font-style: normal;color: red;height: 40px;line-height: 40px;padding-left: 20px;font-size:16px;margin-bottom: 10px;}
.gg li{padding-left: 30px;height: 30px;line-height: 30px;font-size: 14px;color: #6a6b6c;}
.bzzx li {padding-left: 30px;height: 30px;line-height: 30px;font-size: 14px;color: #6a6b6c;}
.bzzx  a{color:#fe8f0d;}
.bzzx  a:hover{text-decoration: underline;}
.fl{float: left;}
.fr{float:right;}
  .content{ margin-top:15px;}

  .content .login div{ border:1px solid #EAEAEA; border-top:none; width:208px; height:175px;margin-left:1px; padding:15px 0;}
  .content .login .txt{ width:125px; border:1px solid #D0D0D0; height:25px;}


  .content .login table{ width:200px; height:170px; margin-left:10px;}
  .content .banner{ float:left; width:520px; height:239px; border:1px solid #CCCBCB; padding:1px; margin-left:10px;}
  .content .banner img{ width:520px; height:239px;}

  .content .tzgg{ width:236px; height:238px; float:left; padding-top:7px; padding-left:6px;border:1px solid #D4D4D2;}
  .content .tzgg .top_one{height:100px; padding-right:5px;}
  .content .tzgg .top_one img{ width:109px; height:86px; border:1px solid #D4D4D2; padding:1px; margin-right:5px; float:left;}
  .content .tzgg .top_one .title{ color:#FF0000; line-height:27px;}
  .content .tzgg .top_one .detail{ color:#FF0000; }

  .content .tzgg .list { margin-top:10px; margin-left:5px;}
  .content .tzgg .list li{ padding-left:0px;  line-height:25px; height:25px;}
  .content .tzgg .list li img{ margin-bottom:3px; margin: 2px,2px,2px,2px;}

  .content .program{ margin-top:15px;}
  .content .program a{ display:block; width:143px; height:132px; float:left; border:1px solid #DDDDDD; margin-right:25px;}
  .content .program img{ width:143px; height:132px; }

  .content .other{ margin-top:15px;}
  .content .other a{ display:block; width:303px; height:107px; float:left; border:1px solid #DDDDDD; margin-right:18px; background:#F9F9F9; padding:8px;}

  .footer{ height:120px; margin-top:15px; text-align:center;}
  .footer .copyright{ margin:10px auto; font-size:14px;}
  .footer .bs a{ margin:0 5px;}


  /*登陆页*/

  .content .h2{ text-align:center; color:#003B93; font-weight:600; font-size:25px; margin-top:40px; margin-bottom:35px;}

  .content .jf{ height:350px; border:1px solid #E9E9E9; padding:1px;}

  .content .jf .dlck{ width:350px; height:280px; border:1px solid #CECECE; background:#F4F4F4; margin-top:8px; margin-left:8px; padding:15px; font-size:14px; font-weight:400; line-height:30px;}
  .content .jf .dlck .h3{text-align:center; color:#FF0000; font-weight:600; font-size:20px; padding-top:20px;}

  .content .jf .dlck .ts{ height:55px; border-bottom:1px dashed #666666; text-align:center; margin-top:15px;}
  .content .jf .dlck p{ text-align:center;}

  .content .jf .dlck dl{ margin-top:20px;}
  .content .jf .dlck .dd{ width:345px; height:30px; margin-bottom:18px;}
  /* .Copy{width:100%0px; height:200px; margin:0px auto; font-size:12px; color:#666666; text-align:center; line-height:200%; margin-top:10px; background-color: #fff} */

</style>


// WEBPACK FOOTER //
// LoginDormOld.vue?0a897096